import type Vue from 'vue';
import type { ThemeSettings } from '@cognitoforms/types/server-types/forms/configuration/theme-settings';

export class PaymentFormStyle {
	readonly color?: string;
	readonly placeholderColor?: string;
	readonly fontFamily?: string;
	readonly fontUrl?: string;
	readonly lineHeight?: string;
	readonly fontSize?: string;
	readonly fontWeight?: string;
	readonly borderColor?: string;
	readonly borderWidth?: string;
	readonly borderStyle?: string;
	readonly borderRadius?: string;
	readonly boxShadow?: string;
	readonly highlightColor?: string;
	readonly negativeColor?: string;
	readonly textColor?: string;
	readonly computedStyles: CSSStyleDeclaration;
	readonly focusStyles?: CSSStyleDeclaration;
	readonly styleEl: Element;

	constructor(computedStyles: CSSStyleDeclaration, themeSettings: ThemeSettings, styleEl?: Element, focusStyles?: CSSStyleDeclaration) {
		this.computedStyles = computedStyles;
		this.color = computedStyles['color'];
		this.fontFamily = computedStyles['font-family'];
		this.lineHeight = computedStyles['lineHeight'];
		this.fontSize = computedStyles['fontSize'];
		this.fontWeight = computedStyles['fontWeight'];
		this.borderColor = computedStyles['border-color'];
		this.borderWidth = computedStyles['border-width'];
		this.borderStyle = computedStyles['border-style'];
		this.borderRadius = computedStyles['border-radius'];
		this.boxShadow = computedStyles['box-shadow'];
		this.placeholderColor = themeSettings.PlaceholderText ? themeSettings.PlaceholderText.Color : '#ccc';
		this.highlightColor = themeSettings.HighlightColor ? themeSettings.HighlightColor : 'rgb(26, 152, 255)';
		this.negativeColor = '#cc2a24';
		this.styleEl = styleEl;
		this.focusStyles = focusStyles;

		if (themeSettings.Text) {
			if (themeSettings.Text.FontFamily.indexOf('|') >= 0)
				this.fontUrl = themeSettings.Text.FontFamily.split('|')[1];
			this.textColor = themeSettings.Text.Color;
		}
		else {
			this.textColor = this.color;
		}
	}

	// In the payment dialog we don't want to style the payment fields using the form's theme
	// We create a "fake" PaymentFormStyle object instead to prevent harvesting styles (which doesn't have a style element)
	get useFormTheme() {
		return !!this.styleEl;
	}
}

export function getFormStyles(styleSource: Vue | Element, themeSettings: ThemeSettings): PaymentFormStyle {
	// Get the element to extract styles from
	let styleEl: Element = null;
	if (styleSource) {
		if ('tagName' in styleSource) {
			styleEl = styleSource as Element;
		}
		else {
			const component = styleSource as Vue;
			styleEl = component.$el as Element;
		}
	}

	// Fetch styles from style marker
	styleEl.classList.add('is-focus');
	// convert to a normal object so it doesn't update.
	const focusStyles = { ...getComputedStyle(styleEl) };
	styleEl.classList.remove('is-focus');
	const foundStyles = getComputedStyle(styleEl);

	return new PaymentFormStyle(foundStyles, themeSettings, styleEl, focusStyles);
}
